import { render, staticRenderFns } from "./MintalMesPrdProductionEquipQuotaList.vue?vue&type=template&id=472c4b9d&"
import script from "./MintalMesPrdProductionEquipQuotaList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdProductionEquipQuotaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports